
angular.module('dyb.students.demographics', [
        'classy', 'dyb.util.forms']);
